var _rect, _rect2, _path, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDryer = function SvgDryer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    x: 1.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 5.5,
    y: 6.5,
    stroke: "currentColor",
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.335 12.972c.383-.364 1.249-1.3.184-1.716-1.305-.51-.497-1.49.382-2.256M8.335 12.972c.383-.364 1.249-1.3.184-1.716-1.305-.51-.497-1.49.382-2.256"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 14.5,
    y: 2.5,
    fill: "currentColor",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    x: 3.5,
    y: 3,
    fill: "currentColor",
    rx: 0.5
  })));
};
export default SvgDryer;